/*
 * @Author: Huangxianlong
 * @Date: 2023-08-10 16:51:23
 * @LastEditors: Huangxianlong
 * @LastEditTime: 2023-08-12 10:32:46
 * @FilePath: \monitor\src\language\user\index.js
 * @Description: 
 */
//登录及注册等翻译文件的汇总，在此页汇总一个模块（如这里的user用户模块）的翻译文件并暴露出去
import Login from "./login";
import Meta from "./meta";
import Register from "./register";
import Main from "./main";
import Alarm from "./alarm";
const CN = {
  Login: Login.CN,
  Meta: Meta.CN,
  Register: Register.CN,
  Main: Main.CN,
  Alarm: Alarm.CN,
};
const EN = {
  Login: Login.EN,
  Meta: Meta.EN,
  Register: Register.EN,
  Main: Main.EN,
  Alarm: Alarm.EN,
};
export default {
  CN,
  EN
};



// WEBPACK FOOTER //
// ./src/language/user/index.js